import type { BasicServiceExecutionFragment } from '@drycut/graphql';

import { formatDateTime } from '@drycut/ui-format-utils';

type Props = {
  serviceExecution: BasicServiceExecutionFragment;
};

export function ExpectedTime({ serviceExecution }: Props): React.ReactElement {
  // Projected start time calculation. If it's a pre-booked service we use the projected book time,
  // otherwise we calculate it based on the createdAt time and projected waiting time.
  const projectedStartTime = serviceExecution.projectedBookTime
    ? serviceExecution.projectedBookTime
    : serviceExecution.projectedStartTime;

  return (
    <span>
      {formatDateTime(projectedStartTime ?? '', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      })}
    </span>
  );
}
